/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SupplementalGetOrCreateFormInstanceResponseAllOfFormInstance } from './SupplementalGetOrCreateFormInstanceResponseAllOfFormInstance';
import {
    SupplementalGetOrCreateFormInstanceResponseAllOfFormInstanceFromJSON,
    SupplementalGetOrCreateFormInstanceResponseAllOfFormInstanceFromJSONTyped,
    SupplementalGetOrCreateFormInstanceResponseAllOfFormInstanceToJSON,
} from './SupplementalGetOrCreateFormInstanceResponseAllOfFormInstance';
import type { SupplementalLocale } from './SupplementalLocale';
import {
    SupplementalLocaleFromJSON,
    SupplementalLocaleFromJSONTyped,
    SupplementalLocaleToJSON,
} from './SupplementalLocale';

/**
 * 
 * @export
 * @interface SupplementalGetOrCreateFormInstanceResponse
 */
export interface SupplementalGetOrCreateFormInstanceResponse {
    /**
     * 
     * @type {string}
     * @memberof SupplementalGetOrCreateFormInstanceResponse
     */
    recipient_id: string;
    /**
     * 
     * @type {string}
     * @memberof SupplementalGetOrCreateFormInstanceResponse
     */
    account_uuid: string;
    /**
     * 
     * @type {string}
     * @memberof SupplementalGetOrCreateFormInstanceResponse
     */
    quote_uuid: string | null;
    /**
     * 
     * @type {string}
     * @memberof SupplementalGetOrCreateFormInstanceResponse
     */
    policyholder_email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SupplementalGetOrCreateFormInstanceResponse
     */
    jira_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SupplementalGetOrCreateFormInstanceResponse
     */
    broker_uuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SupplementalGetOrCreateFormInstanceResponse
     */
    broker_email?: string | null;
    /**
     * 
     * @type {SupplementalLocale}
     * @memberof SupplementalGetOrCreateFormInstanceResponse
     */
    locale: SupplementalLocale;
    /**
     * 
     * @type {string}
     * @memberof SupplementalGetOrCreateFormInstanceResponse
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplementalGetOrCreateFormInstanceResponse
     */
    updated_at?: string;
    /**
     * 
     * @type {SupplementalGetOrCreateFormInstanceResponseAllOfFormInstance}
     * @memberof SupplementalGetOrCreateFormInstanceResponse
     */
    form_instance?: SupplementalGetOrCreateFormInstanceResponseAllOfFormInstance;
}

/**
 * Check if a given object implements the SupplementalGetOrCreateFormInstanceResponse interface.
 */
export function instanceOfSupplementalGetOrCreateFormInstanceResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "recipient_id" in value;
    isInstance = isInstance && "account_uuid" in value;
    isInstance = isInstance && "quote_uuid" in value;
    isInstance = isInstance && "locale" in value;

    return isInstance;
}

export function SupplementalGetOrCreateFormInstanceResponseFromJSON(json: any): SupplementalGetOrCreateFormInstanceResponse {
    return SupplementalGetOrCreateFormInstanceResponseFromJSONTyped(json, false);
}

export function SupplementalGetOrCreateFormInstanceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplementalGetOrCreateFormInstanceResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'recipient_id': json['recipient_id'],
        'account_uuid': json['account_uuid'],
        'quote_uuid': json['quote_uuid'],
        'policyholder_email': !exists(json, 'policyholder_email') ? undefined : json['policyholder_email'],
        'jira_id': !exists(json, 'jira_id') ? undefined : json['jira_id'],
        'broker_uuid': !exists(json, 'broker_uuid') ? undefined : json['broker_uuid'],
        'broker_email': !exists(json, 'broker_email') ? undefined : json['broker_email'],
        'locale': SupplementalLocaleFromJSON(json['locale']),
        'created_at': !exists(json, 'created_at') ? undefined : json['created_at'],
        'updated_at': !exists(json, 'updated_at') ? undefined : json['updated_at'],
        'form_instance': !exists(json, 'form_instance') ? undefined : SupplementalGetOrCreateFormInstanceResponseAllOfFormInstanceFromJSON(json['form_instance']),
    };
}

export function SupplementalGetOrCreateFormInstanceResponseToJSON(value?: SupplementalGetOrCreateFormInstanceResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'recipient_id': value.recipient_id,
        'account_uuid': value.account_uuid,
        'quote_uuid': value.quote_uuid,
        'policyholder_email': value.policyholder_email,
        'jira_id': value.jira_id,
        'broker_uuid': value.broker_uuid,
        'broker_email': value.broker_email,
        'locale': SupplementalLocaleToJSON(value.locale),
        'created_at': value.created_at,
        'updated_at': value.updated_at,
        'form_instance': SupplementalGetOrCreateFormInstanceResponseAllOfFormInstanceToJSON(value.form_instance),
    };
}

